import { jsxs as v, jsx as d } from "react/jsx-runtime";
import "../../constants.js";
import { getBorderRadius as x } from "../../utils/get-border-radius.js";
import g from "clsx";
import { Slot as B, Slottable as N } from "@radix-ui/react-slot";
import { forwardRef as j } from "react";
import '../../assets/button.css';const C = "_button_1hd7s_1", R = "_button__icon_1hd7s_210", t = {
  button: C,
  "button--outline": "_button--outline_1hd7s_81",
  "button--transparent": "_button--transparent_1hd7s_82",
  "button--secondary": "_button--secondary_1hd7s_119",
  "button--tertiary": "_button--tertiary_1hd7s_143",
  "button--destructive": "_button--destructive_1hd7s_167",
  "button--icon-only": "_button--icon-only_1hd7s_195",
  "button--icon-end": "_button--icon-end_1hd7s_206",
  button__icon: R,
  "button--layout-full-width": "_button--layout-full-width_1hd7s_250",
  "button--relative": "_button--relative_1hd7s_260",
  "button--expand": "_button--expand_1hd7s_264",
  "button--width-auto": "_button--width-auto_1hd7s_282",
  "button--width-full-width": "_button--width-full-width_1hd7s_286",
  "button--width-fit-content": "_button--width-fit-content_1hd7s_290",
  "button--width-sm": "_button--width-sm_1hd7s_294",
  "button--width-md": "_button--width-md_1hd7s_299",
  "button--width-lg": "_button--width-lg_1hd7s_304",
  "button--small": "_button--small_1hd7s_309",
  "button--responsive": "_button--responsive_1hd7s_317"
}, S = j(
  ({
    asChild: e,
    className: i = "",
    iconOnly: l,
    rounded: _,
    iconPosition: s,
    children: r,
    variant: n,
    decoration: u,
    layout: h,
    icon: b,
    expand: a,
    style: c = {},
    responsive: m,
    width: o = "fit-content",
    relative: p,
    small: w,
    ...f
  }, y) => /* @__PURE__ */ v(
    e ? B : "button",
    {
      ref: y,
      className: g(
        {
          [t.button]: !0,
          [t["button--relative"]]: p,
          [t["button--primary"]]: n === "primary",
          [t["button--secondary"]]: n === "secondary",
          [t["button--tertiary"]]: n === "tertiary",
          [t["button--destructive"]]: n === "destructive",
          [t["button--solid"]]: u === "solid",
          [t["button--outline"]]: u === "outline",
          [t["button--transparent"]]: u === "transparent",
          [t["button--responsive"]]: m,
          [t["button--layout-full-width"]]: h === "full-width",
          [t["button--width-auto"]]: o === "auto",
          [t["button--width-full-width"]]: o === "full-width",
          [t["button--width-fit-content"]]: o === "fit-content",
          [t["button--width-sm"]]: o === "sm",
          [t["button--width-md"]]: o === "md",
          [t["button--width-lg"]]: o === "lg",
          [t["button--icon"]]: !!b,
          [t["button--icon-only"]]: l,
          [t["button--icon-start"]]: s === "start",
          [t["button--icon-end"]]: s === "end",
          [t["button--expand"]]: !!a,
          [t["button--small"]]: !!w
        },
        i
      ),
      style: {
        ..._ && { "--button-rounded": x(_) },
        ...c
      },
      ...f,
      children: [
        b && /* @__PURE__ */ d("span", { className: t.button__icon, children: b }),
        /* @__PURE__ */ d(N, { children: r })
      ]
    }
  )
);
S.displayName = "Button";
export {
  S as Button
};
